import React from 'react';
const tomes = [{
  number: '01',
  title: 'Anatomía, Fisiología y Bioquímica para Nutrición',
  desc: 'Bases del cuerpo humano, sistemas, metabolismo celular y bioquímica aplicada a la carrera.'
}, {
  number: '02',
  title: 'Nutrición Normal y Alimentación Saludable',
  desc: 'Macronutrientes, micronutrientes, requerimientos, GAPA y alimentación en todas las etapas de vida.'
}, {
  number: '03',
  title: 'Alimentos, Bromatología y Técnica Dietética',
  desc: 'Composición de alimentos, conservación, higiene, CAA y técnicas de preparación.'
}, {
  number: '04',
  title: 'Evaluación Nutricional y Dietoterapia',
  desc: 'Antropometría, indicadores clínicos, diagnóstico nutricional y planes para las patologías más frecuentes.'
}, {
  number: '05',
  title: 'Salud Pública y Nutrición Comunitaria',
  desc: 'Epidemiología nutricional, políticas alimentarias, ENNyS, EAN y programas nacionales.'
}, {
  number: '06',
  title: 'Investigación, Gestión y Práctica Profesional',
  desc: 'Metodología de investigación, bioestadística, gestión en servicios de alimentación y ejercicio profesional.'
}];
const includes = ['Fórmulas de cálculo energético y valores de referencia listos para exámenes', 'Casos clínicos resueltos paso a paso por patología y etapa de vida', 'Checklists de valoración nutricional por área', 'Resúmenes, mnemotecnias y autoevaluación por unidad'];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(220,252,231) 0%, rgb(240,253,244) 50%, rgb(255,255,255) 100%)'
  }} data-id="element-352">
      <div className="mx-auto max-w-4xl" data-id="element-353">

        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-354">
          Lo que <span className="text-green-700" data-id="element-355">recibís</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-356">
          6 tomos · +360 páginas · Toda la carrera organizada
        </p>

        {/* Tomos */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-357">
          {/* Header */}
          <div className="bg-green-700 px-5 py-2.5" data-id="element-358">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-359">
              📚 LOS 6 TOMOS — Toda la carrera en un solo lugar
            </h3>
          </div>

          {/* Tomes list */}
          <div className="divide-y divide-gray-100" data-id="element-360">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-2.5" data-id="element-361">
                <span className="shrink-0 text-lg font-black text-green-700/30 w-8 text-center" data-id="element-362">
                  {tome.number}
                </span>
                <div className="flex-1 min-w-0" data-id="element-363">
                  <span className="block text-sm font-black text-gray-900" data-id="element-364">
                    {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-365">
                    {tome.desc}
                  </span>
                </div>
                <span className="shrink-0 text-[10px] font-bold text-green-700 bg-green-700/5 border border-green-700/20 rounded-full px-2 py-0.5" data-id="element-366">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <div className="grid grid-cols-2 gap-2" data-id="element-367">
          {includes.map(item => <div key={item} className="flex items-start gap-2 bg-white border border-green-700/20 rounded-lg px-4 py-2.5" data-id="element-368">
              <span className="shrink-0 text-green-700 font-bold text-sm" data-id="element-369">
                ✅
              </span>
              <span className="text-xs text-gray-700 leading-5" data-id="element-370">{item}</span>
            </div>)}
        </div>

      </div>
    </section>;
}